module.exports = __webpack_public_path__ + "img/sidebar-bg.33be8e18.png";